import type { Bexrapport } from "@/types/bexSupport";
import type { BexrapportState } from "@/types/store";
import type { MutationTree } from "vuex";

// Mutations
export const LOAD_BEXRAPPORTS = "LOAD_BEXRAPPORTS";
export const LOAD_BEXRAPPORTS_SUCCESS = "LOAD_BEXRAPPORTS_SUCCESS";
export const LOAD_BEXRAPPORTS_FAILURE = "LOAD_BEXRAPPORTS_FAILURE";

export const LOAD_BEXRAPPORT = "LOAD_BEXRAPPORT";
export const LOAD_BEXRAPPORT_SUCCESS = "LOAD_BEXRAPPORT_SUCCESS";
export const LOAD_BEXRAPPORT_FAILURE = "LOAD_BEXRAPPORT_FAILURE";

export const ADD_BEXRAPPORT = "ADD_BEXRAPPORT";
export const ADD_BEXRAPPORT_SUCCESS = "ADD_BEXRAPPORT_SUCCESS";
export const ADD_BEXRAPPORT_FAILURE = "ADD_BEXRAPPORT_FAILURE";

export const UPDATE_BEXRAPPORT = "UPDATE_BEXRAPPORT";
export const UPDATE_BEXRAPPORT_SUCCESS = "UPDATE_BEXRAPPORT_SUCCESS";
export const UPDATE_BEXRAPPORT_FAILURE = "UPDATE_BEXRAPPORT_FAILURE";

export const DELETE_BEXRAPPORT = "DELETE_BEXRAPPORT";
export const DELETE_BEXRAPPORT_SUCCESS = "DELETE_BEXRAPPORT_SUCCESS";
export const DELETE_BEXRAPPORT_FAILURE = "DELETE_BEXRAPPORT_FAILURE";

export const mutations: MutationTree<BexrapportState> = {
  [LOAD_BEXRAPPORTS](state: BexrapportState) {
    state.bexrapports = {
      ...state.bexrapports,
      loading: true,
      error: null,
    };
  },
  [LOAD_BEXRAPPORTS_SUCCESS](state: BexrapportState, data: any) {
    state.bexrapports = {
      data: data.data,
      loading: false,
      error: null,
      count: data.total_count,
    };
  },
  [LOAD_BEXRAPPORTS_FAILURE](state: BexrapportState, error: string) {
    state.bexrapports = { ...state.bexrapports, loading: false, error };
  },
  [ADD_BEXRAPPORT](state: BexrapportState) {
    state.bexrapports = {
      ...state.bexrapports,
      loading: true,
      error: null,
    };
  },
  [ADD_BEXRAPPORT_SUCCESS](state: BexrapportState, bexrapport: Bexrapport) {
    state.bexrapports = {
      ...state.bexrapports,
      data: [...state.bexrapports.data, bexrapport],
      loading: false,
      error: null,
    };
  },
  [ADD_BEXRAPPORT_FAILURE](state: BexrapportState, error: string) {
    state.bexrapports = { ...state.bexrapports, loading: false, error };
  },
  [UPDATE_BEXRAPPORT](state: BexrapportState) {
    state.bexrapports = {
      ...state.bexrapports,
      loading: true,
      error: null,
    };
  },
  [UPDATE_BEXRAPPORT_SUCCESS](state: BexrapportState, bexrapport: any) {
    state.bexrapports.loading = false;
    state.bexrapports.error = null;
    const index = state.bexrapports.data.findIndex(
      (item: any) => item.id === bexrapport.id,
    );
    if (index !== -1) state.bexrapports.data[index] = bexrapport;
  },
  [UPDATE_BEXRAPPORT_FAILURE](state: BexrapportState, error: string) {
    state.bexrapports = { ...state.bexrapports, loading: false, error };
  },

  [LOAD_BEXRAPPORT](state: BexrapportState) {
    state.bexrapport = { ...state.bexrapport, loading: true, error: null };
  },
  [LOAD_BEXRAPPORT_SUCCESS](state: BexrapportState, event: Bexrapport) {
    state.bexrapport = {
      data: event,
      loading: false,
      error: null,
    };
  },
  [LOAD_BEXRAPPORT_FAILURE](state: BexrapportState, error: string) {
    state.bexrapport = {
      ...state.bexrapport,
      loading: false,
      error: error,
    };
  },

  [DELETE_BEXRAPPORT](state: BexrapportState) {
    state.bexrapports = { ...state.bexrapports, loading: true, error: null };
  },
  [DELETE_BEXRAPPORT_SUCCESS](state: BexrapportState, id: any) {
    state.bexrapports = {
      data: state.bexrapports.data.filter(
        (sc: Bexrapport) => sc.bsReportId !== id,
      ),
      loading: false,
      error: null,
      count: state.bexrapports.count - 1,
    };
  },
  [DELETE_BEXRAPPORT_FAILURE](state: BexrapportState, error: string) {
    state.bexrapports = {
      ...state.bexrapports,
      loading: false,
      error: error,
    };
  },
};
